// NotificationModal.js
import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import { Alert } from '@mui/material';
import PropTypes from 'prop-types';
import ErrorIcon from '@mui/icons-material/Error';
import WarningIcon from '@mui/icons-material/Warning';
import InfoIcon from '@mui/icons-material/Info';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
  p: 3,
};

const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  mb: 2,
};

const iconStyle = {
  marginRight: 1,
};

const buttonStyle = {
  display: 'block',
  marginTop: 2,
  width: '100%',
};

const NotificationModal = ({ open, onClose, message, type }) => {
  let icon;
  switch (type) {
    case 'error':
      icon = <ErrorIcon color="error" sx={iconStyle} />;
      break;
    case 'warning':
      icon = <WarningIcon color="warning" sx={iconStyle} />;
      break;
    case 'info':
      icon = <InfoIcon color="info" sx={iconStyle} />;
      break;
    default:
      icon = null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="notification-modal-title"
      aria-describedby="notification-modal-description"
    >
      <Box sx={modalStyle}>
        <Box sx={headerStyle}>
          {icon}
          <Typography id="notification-modal-title" variant="h6" component="h2">
          AVISO
          </Typography>
        </Box>
        <Alert severity={type} sx={{ mb: 2 }}>
          {message}
        </Alert>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          sx={buttonStyle}
        >
          Cerrar
        </Button>
      </Box>
    </Modal>
  );
};

NotificationModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  message: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['error', 'warning', 'info']).isRequired,
};

export default NotificationModal;
